// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__d0y7i","info":"UpdateTermsInfo_info__3uDlC"};